import Tooltip from 'storybookConfig/stories/cells/Tooltip';

import Icon from 'storybookConfig/stories/molecules/Icon';

const InfoTooltip = ({ children }: { children: React.ReactNode }) => {
  return (
    <Tooltip>
      <Tooltip.Trigger asChild>
        <Icon name="info" />
      </Tooltip.Trigger>
      <Tooltip.Content>{children}</Tooltip.Content>
    </Tooltip>
  );
};

export default InfoTooltip;
